import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import api from '../api';
import Header from '../Components/Header';

const SignUp = () => {
  const navigate = useNavigate();

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const response = await api.post('users/auth/google/', {
        credential: credentialResponse.credential
      });

      navigate('/');
    } catch (error) {
      console.error('Google login error:', error);
      alert('구글 로그인에 실패했습니다.');
    }
  };

  return (
    <div className="bg-white">
      <Header />
    <div className="min-h-screen flex items-center justify-center">
      <div className="w-full max-w-md px-6 py-8">
        <h1 className="text-2xl font-bold text-center mb-8">
          <Link to="/">SWITCHUP</Link>
        </h1>
        <p className="text-center mb-8">
          이미 회원이신가요?{' '}
          <Link to="/login" className="text-blue-600 hover:text-blue-800">
            로그인 하기
          </Link>
        </p>

        <div className="space-y-4">
          <Link
            to="/signupemail"
            className="w-full py-2 bg-blue-600 text-white rounded-md font-semibold hover:bg-blue-700 transition duration-200 flex items-center justify-center"
          >
            이메일로 가입하기
          </Link>

          <div className="mt-4">
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={() => {
                console.error('Login Failed');
                alert('구글 로그인에 실패했습니다.');
              }}
              useOneTap={false}
              theme="outline"
              shape="rectangular"
              type="standard"
              width="100%"
              text="구글로 시작하기"  // 이 속성은 유지
              locale="ko"
            />
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default SignUp;